import { render, staticRenderFns } from "./CitiesDropdown.vue?vue&type=template&id=74f9ccd7&scoped=true&"
import script from "./CitiesDropdown.vue?vue&type=script&lang=ts&"
export * from "./CitiesDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./CitiesDropdown.vue?vue&type=style&index=0&id=74f9ccd7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9ccd7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixLink: require('/root/project/frontend/src/components/BixLink.vue').default,BixImg: require('/root/project/frontend/src/components/images/BixImg.vue').default})
